<template>
  <span>
    <el-dropdown
        v-if="isLoggedIn"
        class="topicOptions"
        @command="handleTopicActions"
        trigger="click"
    >
              <span class="el-dropdown-link">
                <i class="el-icon-more-outline" style="font-size:25px"></i>
              </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
            v-if="admin || user.id === topic.user.id"
            icon="el-icon-edit"
            command="editTopic"
        >
          编辑
        </el-dropdown-item>
        <el-dropdown-item
            v-if="admin || user.id === topic.user.id"
            icon="el-icon-delete"
            command="deleteTopic"
        >
          删除
        </el-dropdown-item>
        <el-dropdown-item
            v-if="user.id !== topic.user.id"
            icon="el-icon-circle-close"
            command="reportTopicSpam"
        >举报
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <!--modal for topic edit-->
    <b-modal id="editTopic" centered scrollable size="xl">
      <template v-slot:modal-title>
        <h3
            style="cursor: pointer"
            @click="goToTopicEdit"
            class="text-center"
        >
          编辑话题
          <font-awesome-icon icon="external-link-alt" />
        </h3>
      </template>

      <template v-slot:modal-footer="{ cancel }">
        <el-button @click="cancel()">取消</el-button>
      </template>
      <TopicEdit
          v-bind:editTopic.sync="topic"
          @close="closeEditTopic"
      ></TopicEdit>
    </b-modal>
    <!--modal for topic spam-->
    <b-modal
        id="reportTopicSpam"
        centered
        scrollable
        title="举报话题"
        size="md"
        hide-footer
    >
      <SpamReportComponent
          :topic-id="topic.id"
          @close="closeReportSpam"
      ></SpamReportComponent>
    </b-modal>
  </span>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import SpamReportComponent from "@/components/SpamReportComponent";
import TopicPostComponent from "@/components/TopicPostComponent";


export default {
  props: ["topic", "admin"],
  data: function () {
    return {
      fetching: false,
      topics: [],
      currentPage: 1,
      totalPage: 2,
      loadMoreMessage: "",
      loadedLatestpage: 0
    };
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
    ]),
    ...mapState(["user"]),
  },
  filters: {
    truncate(value) {
      if (value.length > 50) {
        value = value.substring(0, 47) + "...";
      }

      return value;
    }
  },
  methods: {
    goToTopicEdit() {
      window.open("/topics?id=" + this.topic.id, "_blank");
    },
    handleTopicActions: function (command) {
      if (command === "deleteTopic") {
        this.showDeleteTopic();
        return;
      }
      this.$bvModal.show(command);
    },
    closeEditTopic: function() {
      this.$bvModal.hide("editTopic");
      this.$emit('refresh');
    },
    closeReportSpam: function() {
      this.$bvModal.hide("reportTopicSpam");
    },

    showDeleteTopic: function() {
      var wording = "确定永久删除该话题?";
      if (this.admin) {
        wording += " 如果改话题有被举报，举报信息也将被一起删除！";
      }
      this.$confirm(wording, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http
            .delete("/topics/" + this.topic.id)
            .then(() => {
              this.$message({
                type: "success",
                message: "删除成功，跳转到主页面中"
              });
              let self = this;
              setTimeout(function() {
                self.$router.push("/");
              }, 3000);
            })
            .catch(() => {
              this.$message({
                type: "error",
                message: "删除不成功，请稍后再试"
              });
            });
      });
    },
  },

  components: {
    SpamReportComponent,
    TopicEdit: TopicPostComponent,
  }
};
</script>
